import React from 'react';
import MatriculaDataNascimento from './MatriculaDataNascimento';
import DoisFa from './DoisFa';
import { connect } from 'react-redux';

export class MatriculaDataNascimento2fa extends React.Component {
  state = {
    form: {cpf: '', dataNascimento: ''}
  }

  handleChangeInterno = (valid,data) => {
    this.setState({form: {...this.state.form, ...data}})
    this.props.handleFormChange(valid,data);
  }

  render() {
    return (
      <>
        <DoisFa
          handleNenhumaDasOpcoes={this.props.handleNaoEncontrado}
          isOpen={this.props.abre}
          onLogin={this.props.onLogin}
          onHide={this.props.handleFechou} 
          incluirParticipanteHandle={this.props.incluirParticipanteHandle}
          params={this.state.form}
        />

        <MatriculaDataNascimento
          handleFormChange={this.handleChangeInterno}
          tituloMatricula={this.props.tituloMatricula}
        />
      </>
    );
  }
}

const mapStateToProps = store => ({
  evento: store.eventoState.evento.item
});

export default connect(mapStateToProps)(MatriculaDataNascimento2fa);
